import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, throwError } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { environment } from "../../../environments/environment";
import { catchError, map, retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IssueService extends Subject<DataStateChangeEventArgs> {

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  getIssues(projectId) {
    let params = new HttpParams();
    params = params.append('filterBy', 'projectId');
    params = params.append('filterByValue', projectId);
    return this.http.get(`${environment.apiUrl}/issues`, { params: params }).pipe(retry(2), catchError(this.handleError));
  }

   // Create issues
   createIssues(user): Observable<Object> {
    console.log("In createissues method, issues: ", user);
    return this.http.post(`${environment.apiUrl}/issues`, user).pipe(catchError(this.handleError));
  }

   //Delete Issues by Id Delete
   deleteIssues(id: number): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/issues/${id}`).pipe(catchError(this.handleError));
  }

   //Update Issue by Id Put
   updateIssues(user: Object,id: number): Observable<Object> {
    console.log("In createUser method, user: ", user);
    return this.http.put(`${environment.apiUrl}/issues/${id}`, user).pipe(catchError(this.handleError));
  }

   //Get All Issues by Id Get
   getAllIssues(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/issues`).pipe(catchError(this.handleError));
  }
}
